import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoEmployeeList} from "./models/DtoEmployeeList";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {DtoEmployeeBaseItems} from "./models/DtoEmployeeBaseItems";
import {DtoEmployee} from "./models/DtoEmployee";
import {DtoSaveResult} from "../../shared/models/DtoSaveResult";
import {DtoEmployeeInactivitiesForYear} from "./models/DtoEmployeeInactivitiesForYear";
import {DtoEmployeeSickForYear} from "./models/DtoEmployeeSickForYear";
import {DtoSalaryMutation} from "./models/DtoSalaryMutation";
import {DtoEmployeeCreate} from "./models/DtoEmployeeCreate";
import {DtoCustomerAppointment} from "../../shared/models/DtoCustomerAppointment";
import {SharedService} from "../../shared/shared.service";

@Injectable()
export class EmployeeService {
    private apiUrlEmployee: string;
    private dtoEmployeeBaseItems: DtoEmployeeBaseItems;

    constructor(private http: AzureApiService,
                public ss: SharedService) {
        this.apiUrlEmployee = 'employee'
    }

    public getEmployeeList = (): Observable<DtoEmployeeList[]> => {
        return this.http.get<DtoEmployeeList[]>(`${this.apiUrlEmployee}`);
    };

    public getEmployeeById = (id: number): Observable<DtoEmployee> => {
        return this.http.get<DtoEmployee>(`${this.apiUrlEmployee}/${id}`);
    };

    public saveEmployee = (dtoObject: DtoEmployee): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrlEmployee, dtoObject);
    };

    public deleteEmployeeById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlEmployee}/${id}`);
    };

    public getEmployeeBaseItems = (refresh: boolean): Observable<DtoEmployeeBaseItems> => {
        return Observable.create(observer => {
            if (!this.dtoEmployeeBaseItems || refresh) {
                this.http.get<DtoEmployeeBaseItems>(`employee/baseitems`).subscribe(response => {
                    this.dtoEmployeeBaseItems = response;
                    observer.next(this.dtoEmployeeBaseItems);
                    observer.complete();
                });
            } else {
                observer.next(this.dtoEmployeeBaseItems);
                observer.complete();
            }
        });
    };

    createEmployee(dtoObject: DtoEmployeeCreate): Observable<DtoSaveResult> {
        return this.http.post<DtoSaveResult>('employee/create', dtoObject);
    }

    public getEmployeeNextIndex = (): Observable<number> => {
        return this.http.get<number>(`${this.apiUrlEmployee}/nextindex`);
    };

    public checkEmployeeIndexAvailable = (id: number, index: number): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlEmployee}/indexavailable/${id}/${index}`);
    };

    public hasContracts = (id: number): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlEmployee}/hascontracts/${id}`);
    };

    public getEmployeeSalaryMutations = (id: number): Observable<DtoSalaryMutation[]> => {
        return this.http.get<DtoSalaryMutation[]>(`${this.apiUrlEmployee}/salary/${id}`);
    };

    public saveEmployeeSalaryMutation = (dtoObject: DtoSalaryMutation): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(`${this.apiUrlEmployee}/salary`, dtoObject);
    };


    public deleteEmployeeSalaryMutations = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlEmployee}/salary/${id}`);
    };


    public getEmployeeInactivities = (id: number, year: number): Observable<DtoEmployeeInactivitiesForYear> => {
        return this.http.get<DtoEmployeeInactivitiesForYear>(`${this.apiUrlEmployee}/inactivities/${id}/${year}`);
    };

    public getEmployeeSick = (id: number, year: number): Observable<DtoEmployeeSickForYear> => {
        return this.http.get<DtoEmployeeSickForYear>(`${this.apiUrlEmployee}/sick/${id}/${year}`);
    };

    public getTravelDistance = (from: string, to: string): Observable<number> => {
        return this.http.get<number>(`${this.apiUrlEmployee}/traveldistance/${from}/${to}`);
    };

    public getAppointmentsFromDate = (id: number, fromDate: Date): Observable<DtoCustomerAppointment[]> => {
        return this.http.get<DtoCustomerAppointment[]>(`employee/${id}/appointments/${this.ss.formatDate(fromDate,'yyyy-MM-dd')}`);
    }

    public getFutureAppointmentsForBranches = (id: number, branchIds: number[]): Observable<DtoCustomerAppointment[]> => {
        return this.http.post<DtoCustomerAppointment[]>(`employee/${id}/appointments`, branchIds);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-details/employee.service.ts